import i18n from "i18next";
// always load english by default
import "./locales/en.json";
import { initReactI18next } from "react-i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(
    resourcesToBackend((lng, ns, clb) => {
      // load customer specific translations from the customers folder. Maybe find a better way to check that.
      if (lng.length > 5) {
        import(`./customers/locales/${lng}.json`)
          .then((resources) => clb(null, resources))
          .catch(clb);
      } else {
        import(`./locales/${lng}.json`)
          .then((resources) => clb(null, resources))
          .catch(clb);
      }
    })
  )
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    detection: {
      order: ["querystring"],
      caches: [],
    },
  });

i18n.on("languageChanged", (lng) => {
  const isRtlLanguage = lng?.startsWith('ar') || false;
  document.documentElement.setAttribute('lang', lng?.split("-")[0] || 'en');
  document.documentElement.setAttribute('dir', isRtlLanguage ? 'rtl' : 'ltr');
})

export default i18n;
